import saveAs from 'file-saver';
import Papa from 'papaparse';

import { validateStateFile } from './enums/ValidateStateFile.Enum';

export const modifyFile = (file: File, excludedProperties: number[]) => {
  const fileReader = new FileReader();
  fileReader.readAsText(file);
  fileReader.onload = function () {
    if (fileReader.result) {
      const cleanFileContent = fileReader.result.toString().replace(' ', '');
      const parsedFile = Papa.parse(cleanFileContent, { header: true });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const modifiedData = parsedFile.data.map((row: any) => {
        const properties = Object.entries(row).filter(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ([property, value], index) => !excludedProperties.includes(index)
        );
        return Object.fromEntries(properties);
      });
      const modifiedFileContent = Papa.unparse(modifiedData);
      const modifiedFile = new File([modifiedFileContent], file.name, { type: file.type });
      saveAs(modifiedFile);
    }
  };
};

/**
 * Actually only validates if the file is empty.
 * @todo validates if the file is binary.
 * @param file
 */
export const validateFile = (file: File): Promise<validateStateFile> => {
  return new Promise<validateStateFile>((resolve, reject) => {
    if (file.size === 0) {
      reject(validateStateFile.fileEmpty);
    } else {
      resolve(validateStateFile.fileSuccess);
    }
  });
};

// the problem of this function is that reader.readAsText(file); reads the complete file
// and this is dangerous in big files
// export const validateFileTODO = (file: File): Promise<validateStateFile> => {
//   return new Promise<validateStateFile>((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       const data = evt?.target?.result as string;

//       if (!data) return reject(validateStateFile.fileEmpty);

//       const hasSpecialChars = data.search('�') > -1;
//       if (hasSpecialChars) {
//         reject(validateStateFile.CharacterNotAllowed);
//       } else {
//         resolve(validateStateFile.fileSuccess);
//       }
//     };
//     reader.onerror = function () {
//       reject(validateStateFile.fileEmpty);
//     };
//     reader.readAsText(file);
//   });
// };

/**
 * @todo The first results were unsuccessful.
 * This is an idea to send the delimiter to configurationEndpoint
 */
export const getDelimiter = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line import/no-named-as-default-member
    Papa.parse(file, {
      preview: 1, // check only the first 1 rows
      complete: (results) => {
        resolve(results.meta.delimiter);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
};
